import { ReportTypeEditTabs as CompReportTypeEditTabs } from '@/features/report_types/components/ReportTypeEditTabs';
import { r2wc } from '@/wc/helper/render';

const loadingIndicatorClassName = 'enable-loading-indicator';
const loadingIndicatorCss = `
#page-report-types.path-report-types.action-edit {
  .ex-content:has(account-payable-report-type-edit-tabs.${loadingIndicatorClassName})~.loading-backdrop {
    display: block;
  }
}
`;

export class ReportTypeEditTabs extends r2wc(CompReportTypeEditTabs, {
  shadow: 'open',
  props: {
    activeTab: 'string',
    reportTypeId: 'string',
    showCustomFields: 'boolean',
    isReorderingMode: 'boolean',
    isOrderChanged: 'boolean',
    confirmCancelReordering: 'function',
    skipBrowserConfirm: 'function',
    onFinishedLoading: 'function',
  },
}) {
  constructor() {
    super();

    // Inject CSS that allows the component to
    // make the `ap_web` full-screen loading indicator visible
    const style = document.createElement('style');
    style.innerHTML = loadingIndicatorCss;
    document.head.append(style);

    // Add a class that makes the indicator visible.
    // This is called early enough that it basically feels like the indicator
    // is visible from the beginning.
    this.classList.add(loadingIndicatorClassName);

    // Remove the class after the component loads and calls a callback.
    //@ts-ignore
    this.onFinishedLoading = () =>
      this.classList.remove(loadingIndicatorClassName);
  }
}
